// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as AnomalyImg from "common/src/AnomalyImg.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as TbLegendAugment from "../team-planner-core/TbLegendAugment.bs.js";
import * as TbAugmentsModal17 from "../team-planner17/TbAugmentsModal17.bs.js";
import Add from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";

function TbAugmentSelection18(Props) {
  var augments = Props.augments;
  var setAugments = Props.setAugments;
  var set = TftSet.use(undefined);
  var commonT = Translation.useT(/* Common */0);
  var t = Translation.useT(/* Augments */4);
  var match = React.useState(function () {
        return false;
      });
  var setModalOpen = match[1];
  var onSelectAugment = React.useCallback((function (augId) {
          Curry._1(setAugments, (function (augs) {
                  return Belt_Array.concat(augs, [augId]);
                }));
          return Curry._1(setModalOpen, (function (param) {
                        return false;
                      }));
        }), []);
  return React.createElement(React.Fragment, undefined, React.createElement(ContentSection.make, {
                  className: "p-0 py-3 pb-2 hidden xl:block h-full w-[124px]" + (
                    augments.length === 0 ? "ss-hidden" : ""
                  ),
                  children: React.createElement("div", {
                        className: "flex flex-col items-center gap-3"
                      }, augments.length < 3 ? React.createElement("div", {
                              className: "font-medium leading-none"
                            }, commonT("Augments")) : null, Belt_Array.map(augments, (function (id) {
                              if (id.startsWith("l|")) {
                                var parts = id.split("|");
                                var legend = Belt_Array.getExn(parts, 1);
                                var id2 = Belt_Array.get(parts, 2);
                                var text = id2 !== undefined ? t(id2) : commonT(legend);
                                return React.createElement("div", {
                                            key: id,
                                            className: "flex flex-col items-center cursor-pointer",
                                            onClick: (function (param) {
                                                return Curry._1(setAugments, (function (augs) {
                                                              return Belt_Array.keep(augs, (function (augId) {
                                                                            return augId !== id;
                                                                          }));
                                                            }));
                                              })
                                          }, id2 !== undefined ? React.createElement(TbLegendAugment.Base.make, {
                                                  legend: legend,
                                                  augId: id2,
                                                  size: 58
                                                }) : React.createElement("img", {
                                                  className: "border-2 border-white2 rounded-full",
                                                  height: "58",
                                                  src: "https://ap.tft.tools/img/sup9/legends/" + legend + ".png",
                                                  width: "58"
                                                }), React.createElement("div", {
                                                className: "text-center text-xs pt-[5px] px-2"
                                              }, text));
                              }
                              var match = Dict.get(Data.augments(set), id);
                              if (match !== undefined) {
                                return React.createElement("div", {
                                            key: id,
                                            className: "flex flex-col items-center cursor-pointer",
                                            onClick: (function (param) {
                                                return Curry._1(setAugments, (function (augs) {
                                                              return Belt_Array.keep(augs, (function (augId) {
                                                                            return augId !== id;
                                                                          }));
                                                            }));
                                              })
                                          }, React.createElement(AugmentImage.make, {
                                                augId: id,
                                                size: 58
                                              }), React.createElement("div", {
                                                className: "text-center text-xs pt-[5px] px-2"
                                              }, t(id)));
                              } else {
                                return React.createElement("div", {
                                            key: id,
                                            className: "w-full cursor-pointer h-[79px] flex flex-col justify-center",
                                            onClick: (function (param) {
                                                return Curry._1(setAugments, (function (augs) {
                                                              return Belt_Array.keep(augs, (function (augId) {
                                                                            return augId !== id;
                                                                          }));
                                                            }));
                                              })
                                          }, React.createElement(AnomalyImg.make, {
                                                id: id
                                              }));
                              }
                            })), augments.length <= 2 ? React.createElement("div", {
                              className: "pt-4"
                            }, React.createElement(IconButton, {
                                  onClick: (function (param) {
                                      return Curry._1(setModalOpen, (function (param) {
                                                    return true;
                                                  }));
                                    }),
                                  children: React.createElement(Add, {})
                                })) : null)
                }), React.createElement(TbAugmentsModal17.make, {
                  modalOpen: match[0],
                  setModalOpen: setModalOpen,
                  augments: augments,
                  onSelectAugment: onSelectAugment
                }));
}

var make = React.memo(TbAugmentSelection18);

export {
  make ,
  
}
/* make Not a pure module */
